var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-center"},[_c('p',[_vm._v("Etes-vous sûr de vouloir supprimer '"),_c('strong',[_vm._v("Ridi Nsimba Luamba")]),_vm._v("'")]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-outline-danger"},[_vm._v("NON")]),_vm._v(" "),_c('button',{staticClass:"ml-3 btn btn-outline-success"},[_vm._v("OUI")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679b8a68","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotions/components/Delete.vue
// module id = 658
// module chunks = 0